<div class="login-bg">
	<div class="login-page">
		<div class="login-form">
			<form [formGroup]="formGroup" (ngSubmit)="login()" class="form-container">
				<img
					src="{{ bannerLink }}"
					alt=""
					class="mobile-img"
				/>
					<div class="sign-in-text">Digital Rep Portal</div>
					<div class="pt-sm">{{ "auth.loginDesc" | translate }}</div>
						<div class="input-container">		
							<mat-form-field appearance="outline">
								<mat-label>{{ "auth.yourEmail" | translate }}</mat-label>
								<input
									matInput
									required
									class="bold-input"
									formControlName="email"
									autocomplete="email"
								/>
								<mat-error>{{ "error.emailRequired" | translate }}</mat-error>
							</mat-form-field>
							<mat-form-field appearance="outline">
								<mat-label>{{ "auth.yourPass" | translate }}</mat-label>
								<input
									matInput
									class="bold-input"
									[type]="hide ? 'password' : 'text'"
									formControlName="password"
									required
								/>
								<button
									type="button"
									mat-icon-button
									matSuffix
									(click)="hide = !hide"
									[attr.aria-label]="'Hide password'"
									[attr.aria-pressed]="hide"
								>
									<mat-icon>{{
										hide ? "visibility_off" : "visibility"
									}}</mat-icon>
								</button>
								<mat-error>{{ "error.passRequired" | translate }}</mat-error>
							</mat-form-field>
							<div class="forgot-password-link">
								<span (click)="goToForgotPass()">
									{{ "auth.forgotPass?" | translate }}
								</span>
							</div>
							<button
								mat-raised-button
								class="login-btn"
								[disabled]="formGroup.invalid"
							>
								{{ "auth.login" | translate }}
							</button>			
						</div>
					
					</form>
		</div>
		<div class="crm-info">
			<img
				src="{{ bannerLink }}"
				alt="mockup-1"
			/>
		</div>
	</div>
</div>
